module.exports = __webpack_public_path__ + "img/feeTitle.1b10f4f1.svg";